module.exports = "<div class=\"mods app-card\">\n  <textarea disabled>{{ document.toJson() }}</textarea>\n</div>\n"